import React, { ReactElement } from 'react'
import { ArtData } from '@/database/art'
import Link from 'next/link'
import LoadImageOnDemand from '@/components/LoadImageOnDemand'
import VotesTooltip from '@/components/tooltips/VotesTooltip'
import Box from '@/components/boxes/Box'

const AirdropCard = ({ artData }: { artData: ArtData }): ReactElement => {
    return (
        <div key={artData.art.id} className="artwork-box center width-hundred max-width-370">
            <div className={'header-container'}>
                <div className="react-flow-image__shadow_blue">
                    <div className="padding-five react-flow__shadow_red">
                        <div className={'header-container'}>
                            <Box caption={'Title'} styleCaption={'small gray'} text={artData.art.title} />
                        </div>
                        <div className={'header-container'}>
                            <Box
                                caption={'Description'}
                                styleCaption={'small gray'}
                                styleText={'small white'}
                                text={artData.art.prompt}
                            />
                        </div>
                        <div className="padding-five airdrop-image-container">
                            <LoadImageOnDemand
                                id={'art' + artData.art.id}
                                alt={artData.art.prompt}
                                imageId={artData.image.id}
                                style="z-index-zero"
                                link={'/crazy#nft-' + artData.tokenId + '/'}
                                objectFit="cover"
                                useFill={true}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className={'z-index-one'}>
                <div className={'header-container'}>
                    <Box caption={'NFT'} text={'#' + (artData.tokenId ? artData.tokenId : artData.art.id)} />
                    <div id={'votes' + artData.art.id}>
                        <Box
                            caption={'Votes'}
                            styleCaption={'gradient-text bold'}
                            text={artData.claimPower.toFixed(2)}
                        />
                    </div>
                    <Link
                        href={
                            artData.art.x
                                ? `https://twitter.com/yourtokenart/status/${artData.art.x}`
                                : 'https://twitter.com/yourtokenart'
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <button type="button" className=" nav__medium" onClick={() => {}}>
                            Apply
                        </button>
                    </Link>
                </div>
                <VotesTooltip artData={artData} />
            </div>
        </div>
    )
}

export default AirdropCard
